/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
import { Group, Space } from '@mantine/core';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { EntityVehicleType } from '../../../../../../models/core/entities.type';
import { Feature } from '../../../../../../utils/constants.utils';
import { formatTimestampToString } from '../../../../../../utils/formatter.utils';

type ViewProps = {
  data: EntityVehicleType[];
};

export default function VehicleView(props: ViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Veículo',
      key: 'residuoVeiculo',
      dataIndex: 'residuoVeiculo',
      sorter: (a: EntityVehicleType, b: EntityVehicleType) =>
        a.residuoVeiculo.localeCompare(b.residuoVeiculo),
    },
    {
      title: 'Descrição',
      key: 'residuoVeiculoDescricao',
      sorter: (a: EntityVehicleType, b: EntityVehicleType) =>
        (a.residuoVeiculoDescricao || '').localeCompare(b.residuoVeiculoDescricao || ''),
      render: (row: EntityVehicleType) => (
        <TableCellEllipsis label={row?.residuoVeiculoDescricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Tipo',
      key: 'proprio',
      sorter: (a: EntityVehicleType, b: EntityVehicleType) =>
        a.proprio === b.proprio ? 0 : a.proprio ? -1 : 1,
      render: (row: EntityVehicleType) => <div>{row?.proprio ? 'Próprio' : 'Terceirizado'}</div>,
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: EntityVehicleType, b: EntityVehicleType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: EntityVehicleType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: EntityVehicleType, b: EntityVehicleType) => {
        const aValue = a.dataCriacao.valueOf();
        const bValue = b.dataCriacao.valueOf();
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: EntityVehicleType) => formatTimestampToString(row.dataCriacao),
    },
  ];

  return (
    <div>
      <Group>
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Veículos" text="" />
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        // size="small"
        dataSource={props.data}
        columns={columns}
        rowKey={(item: EntityVehicleType) => item.idEntidadeResiduoVeiculo || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
}
